import { memo } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import TitledArticleCard from "@coworker/apprestructured/src/task-management/components/TitledArticleCard/TitledArticleCard";

function TitledArticleViewerFragmentDemo() {
  const mockItem = {
    no: "30373588",
    type: "ART",
    name: "Article 1",
    noFormatted: "303.735.88",
    description: "Description for Article 1",
    productTypeName: "mockProductType",
    paNo: "123",
    hfbNo: "123",
    source: "source",
    imageUrl:
      "https://www.ikea.com/se/en/images/products/blahaj-soft-toy-shark__0710175_pe727378_s5.jpg",
    smallImageUrl:
      "https://www.ikea.com/se/en/images/products/blahaj-soft-toy-shark__0710175_pe727378_s5.jpg",
  };
  return (
    <Demo>
      <Name>TitledArticleViewerFragment</Name>
      <Highlight>
        <TitledArticleCard title="replaceWithString" item={mockItem} />
      </Highlight>
    </Demo>
  );
}

export default memo(TitledArticleViewerFragmentDemo);
